import React from 'react'
import { DataItem, NothingMessage, Texto, MomentDatePicker } from '@gravitate-js/excalibrr'
import { Col, Input, Row } from 'antd'
import { useWizardMaster } from '../../../../Contexts/WizardMasterContext'
import moment from 'moment'
import { CounterPartySelect } from './EditSelects/CounterpartySelect'
import { BackhaulStops } from './BackhaulStops'
import { formatTimeWindow } from '../../../../../_SiteWide/OrderDisplay/OrderTimeFormats'
import { DriverNotePreview } from '../DriverNotePreview'
import { RouteMap } from '@components/RouteMap'
const { RangePicker } = MomentDatePicker
export const BackhaulPreview = () => {
  const { wizardOrder, orderStops, isEditingBackhaul, driverNote } = useWizardMaster()
  const { updateBackhaulField } = useWizardMaster()
  const inputOnChange = (e, accessor) => {
    updateBackhaulField(accessor, e.target.value)
  }

  if (wizardOrder) {
    return (
      <div className='order-details-flex items-center'>
        <div
          className='pl-3'
          style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', maxWidth: 800, minWidth: 800 }}
        >
          {driverNote && (
            <div className='driver-note-preview mt-4'>
              <DriverNotePreview />
            </div>
          )}
          <Texto className='my-4 backhaul-header' category='heading'>
            TRANSPORTATION ORDER
          </Texto>

          <BackhaulHeader
            isEditingBackhaul={isEditingBackhaul}
            inputOnChange={inputOnChange}
            wizardOrder={wizardOrder}
            orderStops={orderStops}
          />

          <Row style={{ flex: 5 }}>
            <Col span={24}>
              <div className='order-details-flex' style={{ paddingTop: 16 }}>
                <BackhaulStops isEditingBackhaul={isEditingBackhaul} order={wizardOrder} />
                <BackhaulSummary isEditingBackhaul={isEditingBackhaul} isBackhaul order={wizardOrder} />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    )
  }
  return null
}

export const BackhaulSummary = ({ order, isEditingBackhaul, counterparties }) => {
  const { updateBackhaulWindow } = useWizardMaster()
  const datesOnChange = (dates, dateStrings) => {
    updateBackhaulWindow(dates)
  }
  const blurEndInput = () => {
    // Safe way to access the picker DOM element

    const pickerElement = document.querySelector('.ant-picker-range')
    const endInput = pickerElement?.querySelectorAll('.ant-picker-input')?.[1]
    if (endInput instanceof HTMLElement) {
      endInput.blur()
    }
  }
  return (
    <Row className='order-summary-row'>
      <Col span={15} style={{ borderRadius: '5px 0px 0px 5px' }}>
        <div className='vertical-flex-center'>
          <div className='detail-data-label' style={{ paddingTop: isEditingBackhaul ? 0 : 10 }}>
            Delivery Window
          </div>
          {isEditingBackhaul ? (
            <Row>
              <RangePicker
                format='YYYY-MM-DD h:mmA'
                showTime={{ format: 'h:mmA' }}
                defaultValue={[moment(order.dispatch_window_start), moment(order.dispatch_window_end)]}
                onChange={datesOnChange}
                onCalendarChange={(dates, dateStrings) => {
                  datesOnChange(dates, dateStrings)
                  if (dates?.[0] && !dates?.[1]) {
                    blurEndInput()
                  }
                }}
              />
            </Row>
          ) : (
            <div style={{ fontSize: '1.5em' }} className='detail-data-value pt-2'>
              {formatTimeWindow(order.dispatch_window_start, order.dispatch_window_end, false)}
            </div>
          )}
        </div>
      </Col>

      <Col span={9} className='summary-total-col'>
        {isEditingBackhaul ? (
          <>
            <div className='detail-data-label' style={{ paddingTop: 0 }}>
              Hauling For
            </div>
            <CounterPartySelect
              accessor='hauling_for'
              counterparties={counterparties}
              defaultCounterparty={order.hauling_for}
            />
          </>
        ) : (
          <DataItem label='Hauling For'>{order.hauling_for} </DataItem>
        )}
      </Col>
    </Row>
  )
}
const BackhaulHeader = ({ isEditingBackhaul, inputOnChange, wizardOrder, orderStops }) => {
  const showMapEditing = isEditingBackhaul
  const showMap = !isEditingBackhaul && orderStops
  return (
    <Row className='mb-5 mr-3' flex={1}>
      <Col span={8}>
        <div className=' pt-5 pr-4 pl-5  order-summary-row h-100 vertical-flex-center'>
          <div className='vertical-flex-center'>
            <Texto category='h5' appearance='medium'>
              Load Number
            </Texto>
            {isEditingBackhaul ? (
              <Input
                onChange={(e) => inputOnChange(e, 'load_number')}
                defaultValue={wizardOrder.extra_data.load_number}
              />
            ) : (
              <h2 className='detail-data-value'>{wizardOrder.extra_data.load_number}</h2>
            )}
            <Texto category='h5' appearance='medium'>
              Carrier Code
            </Texto>
            {isEditingBackhaul ? (
              <Input onChange={(e) => inputOnChange(e, 'carrier_code')} defaultValue={wizardOrder.carrier_code} />
            ) : (
              <h2 className='detail-data-value'>{wizardOrder.carrier_code ? wizardOrder.carrier_code : 'N/A'}</h2>
            )}
          </div>
        </div>
      </Col>
      <Col span={16} className='pl-5' style={{ marginBottom: '-36px' }}>
        <div style={{ height: '100%', width: '100%' }}>
          {showMap && <RouteMap stops={orderStops} />}
          {showMapEditing && (
            <NothingMessage title='Route Preview Unavailable' message='The route preview will update upon order save' />
          )}
        </div>
      </Col>
    </Row>
  )
}
